export function cellWidth(width) {
  return width ? { flex: 'none', width } : {}
}

export { default as createTableHead } from './createTableHead'
export { default as createTableItem } from './createTableItem'
